import { render, staticRenderFns } from "./ShareCustomersNQ.vue?vue&type=template&id=aa3bbd2a"
import script from "./ShareCustomersNQ.vue?vue&type=script&lang=js"
export * from "./ShareCustomersNQ.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomersNQ.vue?vue&type=style&index=0&id=aa3bbd2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports